/**
 * Purchase session status constants and utilities.
 * Simplified approach - no local storage, just URL params + API polling.
 */

export const PAYMENT_VERIFICATION_MAX_ATTEMPTS = 6;
export const PAYMENT_VERIFICATION_INTERVAL_MS = 2000;

// Status categories
const SUCCESS_STATUSES = ['paid', 'succeeded', 'successful'] as const;
const PENDING_STATUSES = ['awaiting_verification', 'pending', 'processing', 'payment_redirect'] as const;
const FAILURE_STATUSES = ['failed', 'canceled', 'cancelled', 'expired'] as const;

export type PurchaseVerificationState = 'success' | 'pending' | 'failure' | 'unknown';

/**
 * Normalize a raw status string from API or provider to a known status.
 */
export function normalizePurchaseStatus(status: string | null | undefined): string {
  if (!status) {
    console.log('[Payment] normalizePurchaseStatus: empty status -> unknown');
    return 'unknown';
  }
  const normalized = status.trim().toLowerCase();
  console.log('[Payment] normalizePurchaseStatus:', status, '->', normalized);
  return normalized;
}

/**
 * Map a normalized status to a verification state for UI display.
 */
export function mapStatusToState(status: string): PurchaseVerificationState {
  const normalized = status.toLowerCase();
  
  if ((SUCCESS_STATUSES as readonly string[]).includes(normalized)) {
    console.log('[Payment] mapStatusToState:', normalized, '-> success');
    return 'success';
  }
  
  if ((FAILURE_STATUSES as readonly string[]).includes(normalized)) {
    console.log('[Payment] mapStatusToState:', normalized, '-> failure');
    return 'failure';
  }
  
  if ((PENDING_STATUSES as readonly string[]).includes(normalized)) {
    console.log('[Payment] mapStatusToState:', normalized, '-> pending');
    return 'pending';
  }
  
  console.log('[Payment] mapStatusToState:', normalized, '-> unknown (not in any category)');
  return 'unknown';
}

/**
 * Check if a status represents a successful payment.
 */
export function isSuccessStatus(status: string): boolean {
  return mapStatusToState(status) === 'success';
}
